var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../../sutl';
import { volumeRanges } from './DspConfig';
import { convertNumber, handleTransportError, } from './ParamBridge';
import { Timeouts } from './Timeouts';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValid(obj) {
    if (typeof obj === 'string')
        return obj === 'ok';
    if (obj === undefined || obj === null || typeof obj === 'number')
        return false;
    for (const value of Object.values(obj)) {
        if (!isValid(value))
            return false;
    }
    return true;
}
export class TelephonyBridge {
    constructor(calls, callParticipants, callSupportsInvitationState, maxCallsState, disabledCallsState, control, config, callInList, transport, valueCallback, framework, log) {
        this.calls = calls;
        this.callParticipants = callParticipants;
        this.callSupportsInvitationState = callSupportsInvitationState;
        this.maxCallsState = maxCallsState;
        this.disabledCallsState = disabledCallsState;
        this.control = control;
        this.config = config;
        this.callInList = callInList;
        this.transport = transport;
        this.valueCallback = valueCallback;
        this.framework = framework;
        this.log = log;
        this.pollName = 'telephony';
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.keyMap = {}; // keyMap[eKey] = dKey
        // participantIds[callId][participantKey] = participantId
        this.participantIds = {};
        this.timeouts = new Timeouts();
        this.queryCallParticipantsTimeout = this.timeouts.create();
        this.callSupportsInvitationSubscription = this.callSupportsInvitationState.subscribe((prev) => {
            if (this.framework.phase === 'controlling')
                this.framework.recomputeCaps();
        });
        this.disabledCallsStateSubscription = this.disabledCallsState.subscribe((prev) => {
            if (this.framework.phase === 'controlling')
                this.framework.recomputeCaps();
        });
        this.maxCallsStateSubscription = this.maxCallsState.subscribe((prev) => {
            if (this.framework.phase === 'controlling')
                this.framework.recomputeCaps();
        });
        this.callsSubscription = this.calls.subscribe((key, prevValue) => {
            var _a;
            const newValue = this.calls.values[key];
            const prevCallState = (_a = prevValue === null || prevValue === void 0 ? void 0 : prevValue.callState) !== null && _a !== void 0 ? _a : 'disconnected';
            // Don't send updates for changes while the call is disconnected.
            if ((newValue === null || newValue === void 0 ? void 0 : newValue.callState) === 'disconnected' && prevCallState === 'disconnected') {
                return;
            }
            this.valueCallback('callStatus', this.convertCallStatus(newValue));
        });
        this.callParticipantsSubscription = this.callParticipants.subscribe((event) => {
            const call = this.calls.values[event.callKey];
            if (call === undefined) {
                this.log.error(`no call with key ${event.callKey}`);
                return;
            }
            if (event.type === 'participantChanged') {
                const participantId = this.updateParticipant(call.callId, event.participantKey, event.value === undefined);
                const value = { callId: call.callId, participantId };
                if (event.value !== undefined)
                    value.participant = event.value;
                this.valueCallback('callParticipant', value);
            }
            else if (event.type === 'participantsChanged') {
                const participants = this.updateParticipants(call.callId, event.value);
                const value = { callId: call.callId };
                if (participants !== undefined)
                    value.participants = participants;
                this.valueCallback('callParticipants', value);
            }
        });
        this.queryHandlers.callStatus = this.onQueryCallStatus.bind(this);
        this.setHandlers.answer = this.onAnswer.bind(this);
        this.setHandlers.call = this.onCall.bind(this);
        this.setHandlers.callLayout = this.onCallLayout.bind(this);
        this.setHandlers.consentToRecording = this.onConsentToRecording.bind(this);
        this.setHandlers.dial = this.onDial.bind(this);
        this.setHandlers.hangup = this.onHangup.bind(this);
        this.setHandlers.inviteToCall = this.onInviteToCall.bind(this);
        this.setHandlers.muteParticipant = this.onMuteParticipant.bind(this);
        this.setHandlers.muteParticipantVideo = this.onMuteParticipantVideo.bind(this);
        this.setHandlers.reject = this.onReject.bind(this);
        this.setHandlers.sendHostKey = this.onSendHostKey.bind(this);
        this.setHandlers.sendMeetingCode = this.onSendMeetingCode.bind(this);
        this.setHandlers.sendVideo = this.onSendVideo.bind(this);
        this.setHandlers.spotlightParticipant = this.onSpotlightParticipant.bind(this);
        this.setHandlers.receiveGain = this.onSetReceiveGain.bind(this);
        // TODO: implement set filters for parameters that require it
    }
    destroy() {
        this.queryCallParticipantsTimeout.clear();
        this.timeouts.clearAll();
        this.callSupportsInvitationState.unsubscribe(this.callSupportsInvitationSubscription);
        this.disabledCallsState.unsubscribe(this.disabledCallsStateSubscription);
        this.maxCallsState.unsubscribe(this.maxCallsStateSubscription);
        this.calls.unsubscribe(this.callsSubscription);
        this.callParticipants.unsubscribe(this.callParticipantsSubscription);
    }
    getInitialValues() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            let calls = {};
            try {
                calls = yield this.control.getCalls();
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
            this.calls.clear();
            for (const key of Object.keys(calls)) {
                const ci = Object.assign({}, calls[key]);
                if (ci.receiveGain !== undefined) {
                    if (this.control.receiveGainRange === undefined) {
                        this.log.error('expected receiveGainRange to be defined');
                        ci.receiveGain = 0;
                    }
                    else {
                        ci.receiveGain = convertNumber(ci.receiveGain, volumeRanges.receiveGain.max, volumeRanges.receiveGain.min, this.control.receiveGainRange.max, this.control.receiveGainRange.min, this.control.receiveGainRange.round);
                    }
                }
                this.calls.update(key, ci);
            }
            let callSupportsInvitation = {};
            try {
                callSupportsInvitation = (_c = (yield ((_b = (_a = this.control).getSupportsInvitation) === null || _b === void 0 ? void 0 : _b.call(_a)))) !== null && _c !== void 0 ? _c : {};
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
            this.callSupportsInvitationState.update(callSupportsInvitation);
            let maxCalls = {};
            try {
                maxCalls = yield this.control.getMaxCalls();
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
            this.maxCallsState.update(maxCalls);
            if (this.control.getDisabledCalls !== undefined) {
                let disabledCalls = {};
                try {
                    disabledCalls = yield this.control.getDisabledCalls();
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
                this.disabledCallsState.update(disabledCalls);
            }
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            this.log.warning('poll not implemented for telephony state bridge');
        });
    }
    validate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('validate' in this.control))
                return undefined;
            this.buildKeyMap();
            const results = {};
            for (const [key, config] of Object.entries(this.config)) {
                let result = yield this.control.validate(config, {
                    filter: 'telephony',
                    path: ['telephony', key],
                    type: 'telephony',
                });
                if (isValid(result)) {
                    for (const dupKey of Object.keys(this.config)) {
                        if (dupKey == key)
                            continue;
                        if (this.keyMap[key] === this.keyMap[dupKey]) {
                            if (typeof result === 'string') {
                                result = 'duplicate';
                            }
                            else {
                                for (const prop of Object.keys(result)) {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    result[prop] = 'duplicate';
                                }
                            }
                            break;
                        }
                    }
                }
                results[key] = result;
            }
            return { telephony: results };
        });
    }
    buildKeyMap() {
        if (!('getKey' in this.control))
            return;
        this.keyMap = {};
        for (const eKey of Object.keys(this.config)) {
            const dKey = this.control.getKey(this.config[eKey]);
            this.keyMap[eKey] = dKey;
        }
    }
    convertCallStatus(callStatus) {
        const converted = Object.assign({}, callStatus);
        if (this.callInList && callStatus.callInListId) {
            const key = this.callInList.keyMap[callStatus.callInListId];
            if (key === undefined) {
                this.log.error(`invalid callInList key: ${callStatus.callInListId}`);
            }
            else {
                converted.callInListId = key;
            }
        }
        if (converted.receiveGain !== undefined) {
            if (this.control.receiveGainRange === undefined) {
                this.log.error('expected receiveGainRange to be defined');
            }
            else {
                converted.receiveGain = convertNumber(converted.receiveGain, this.control.receiveGainRange.max, this.control.receiveGainRange.min, volumeRanges.receiveGain.max, volumeRanges.receiveGain.min, 1);
            }
        }
        return converted;
    }
    getParticipantKey(callId, participantId) {
        if (this.participantIds[callId] === undefined) {
            return undefined;
        }
        for (const [key, id] of Object.entries(this.participantIds[callId])) {
            if (id === participantId)
                return key;
        }
        return undefined;
    }
    onAnswer(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = this.calls.getKeyByCallId(value);
            if (key === undefined) {
                this.log.error(`unknown callId = ${value}`);
                return;
            }
            this.transport.removeCommands('poll');
            try {
                const result = yield this.control.answer(key);
                if (result === true) {
                    this.calls.answer(key);
                }
                else if (result !== false) {
                    this.calls.answer(key, result);
                }
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    // We would like to update the state to put the call in the "connecting" state before calling
    // the control's call method. This would provide instant feedback that the call has started
    // connecting. We can't do this because we need the driver to provide the key for the call
    // before we can update the state.
    onCall(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const callValue = value;
            let key;
            this.transport.removeCommands('poll');
            try {
                key = yield this.control.call(callValue);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
            if (key === undefined)
                return;
            this.calls.call(key, callValue.callType, callValue.callId, callValue);
        });
    }
    onCallLayout(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const callLayoutValue = value;
            const key = this.calls.getKeyByCallId(callLayoutValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${callLayoutValue.callId}`);
                return;
            }
            if (this.control.callLayout === undefined) {
                this.log.error('expected callLayout to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                const newValue = yield this.control.callLayout(key, callLayoutValue.value);
                this.calls.updateLayout(key, newValue);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onConsentToRecording(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const consentValue = value;
            const key = this.calls.getKeyByCallId(consentValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${consentValue.callId}`);
                return;
            }
            if (this.control.consentToRecording === undefined) {
                this.log.error('expected sendVideo to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                yield this.control.consentToRecording(key, consentValue.value);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onDial(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialValue = value;
            const key = this.calls.getKeyByCallId(dialValue.callId);
            if (this.control.dial === undefined) {
                this.log.error('not implemented for this driver');
                return;
            }
            if (key === undefined) {
                this.log.error(`unknown callId = ${dialValue.callId}`);
                return;
            }
            this.transport.removeCommands('poll');
            try {
                const newValue = yield this.control.dial(key, dialValue.dialString);
                this.calls.dial(key, newValue);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    // This operates differently from most set handlers. It updates the state to put the call in
    // the "disconnecting" state and calls valueCallback before calling the control's hangup
    // method. This allows Inara to provide instant feedback that the call is disconnecting.
    onHangup(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const hangupValue = value;
            const callId = typeof hangupValue === 'string' ? hangupValue : hangupValue.callId;
            const endMeeting = typeof hangupValue === 'string' ? undefined : hangupValue.endMeeting;
            const key = this.calls.getKeyByCallId(callId);
            if (key === undefined) {
                // Don't report this as an error. This can happen if a synchronized call gets ended by
                // its parent.
                this.log.info(`unknown callId = ${callId}`);
                return;
            }
            this.calls.end(key);
            this.transport.removeCommands('poll');
            try {
                if (yield this.control.hangup(key, endMeeting))
                    this.calls.disconnect(key);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onInviteToCall(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const inviteToCallValue = value;
            const key = this.calls.getKeyByCallId(inviteToCallValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${inviteToCallValue.callId}`);
                return;
            }
            if (this.control.inviteToCall === undefined) {
                this.log.error('expected inviteToCall to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                yield this.control.inviteToCall(key, inviteToCallValue.invitees);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onMuteParticipant(param, setValue) {
        return __awaiter(this, void 0, void 0, function* () {
            const { callId, participantId, value } = setValue;
            const key = this.calls.getKeyByCallId(callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${callId}`);
                return;
            }
            if (this.control.muteParticipant === undefined) {
                this.log.error('expected muteParticipant to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            if (participantId === '*') {
                try {
                    const newValue = yield this.control.muteParticipant(key, '*', value);
                    for (const participantKey of Object.keys(this.participantIds[callId])) {
                        this.callParticipants.mute(key, participantKey, newValue);
                    }
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
            else {
                const participantKey = this.getParticipantKey(callId, participantId);
                if (participantKey === undefined) {
                    this.log.error(`unrecognized participantId ${participantId} for callId ${callId}`);
                    return;
                }
                try {
                    const newValue = yield this.control.muteParticipant(key, participantKey, value);
                    this.callParticipants.mute(key, participantKey, newValue);
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
    onMuteParticipantVideo(param, setValue) {
        return __awaiter(this, void 0, void 0, function* () {
            const { callId, participantId, value } = setValue;
            const key = this.calls.getKeyByCallId(callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${callId}`);
                return;
            }
            if (this.control.muteParticipantVideo === undefined) {
                this.log.error('expected muteParticipantVideo to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            if (participantId === '*') {
                try {
                    const newValue = yield this.control.muteParticipantVideo(key, '*', value);
                    for (const participantKey of Object.keys(this.participantIds[callId])) {
                        this.callParticipants.muteVideo(key, participantKey, newValue);
                    }
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
            else {
                const participantKey = this.getParticipantKey(callId, participantId);
                if (participantKey === undefined) {
                    this.log.error(`unrecognized participantId ${participantId} for callId ${callId}`);
                    return;
                }
                try {
                    const newValue = yield this.control.muteParticipantVideo(key, participantKey, value);
                    this.callParticipants.muteVideo(key, participantKey, newValue);
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
    onSpotlightParticipant(param, setValue) {
        return __awaiter(this, void 0, void 0, function* () {
            const { callId, participantId, value } = setValue;
            const key = this.calls.getKeyByCallId(callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${callId}`);
                return;
            }
            if (this.control.spotlightParticipant === undefined) {
                this.log.error('expected spotlightParticipant to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            if (participantId === '*') {
                try {
                    const newValue = yield this.control.spotlightParticipant(key, '*', value);
                    for (const participantKey of Object.keys(this.participantIds[callId])) {
                        this.callParticipants.spotlight(key, participantKey, newValue);
                    }
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
            else {
                const participantKey = this.getParticipantKey(callId, participantId);
                if (participantKey === undefined) {
                    this.log.error(`unrecognized participantId ${participantId} for callId ${callId}`);
                    return;
                }
                try {
                    const newValue = yield this.control.spotlightParticipant(key, participantKey, value);
                    this.callParticipants.mute(key, participantKey, newValue);
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
    onQueryCallStatus(param) {
        for (const key of Object.keys(this.calls.values)) {
            const callStatus = this.calls.values[key];
            // Don't send disconnected calls in call status query.
            if (callStatus.callState !== 'disconnected') {
                this.valueCallback('callStatus', this.convertCallStatus(this.calls.values[key]));
                // Putting this in a timeout is a hack for SNTY-2447. This hack is not necessary in
                // the new equipment service, so we can live with it here for now because eventually
                // this code will be replaced with the new equipment service.
                this.queryCallParticipantsTimeout.set(() => {
                    const callParticipants = this.callParticipants.values[key];
                    const participants = {};
                    const callId = callStatus.callId;
                    for (const [participantKey, participant] of Object.entries(callParticipants !== null && callParticipants !== void 0 ? callParticipants : {})) {
                        const participantId = this.participantIds[callId][participantKey];
                        if (participantId === undefined) {
                            this.log.error(`no participantId for callKey = ${key}, callId = ${callId}, participantKey = ${participantKey}`);
                            continue;
                        }
                        participants[participantId] = participant;
                    }
                    if (Object.keys(participants).length > 0) {
                        this.valueCallback('callParticipants', { callId, participants });
                    }
                }, 3000);
            }
        }
    }
    onReject(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = this.calls.getKeyByCallId(value);
            if (key === undefined) {
                this.log.error(`unknown callId = ${value}`);
                return;
            }
            this.transport.removeCommands('poll');
            try {
                const update = yield this.control.reject(key);
                if (update)
                    this.calls.disconnect(key);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onSendHostKey(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const sendHostKeyValue = value;
            const key = this.calls.getKeyByCallId(sendHostKeyValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${sendHostKeyValue.callId}`);
                return;
            }
            if (this.control.sendHostKey === undefined) {
                this.log.error('expected sendHostKey to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                yield this.control.sendHostKey(key, sendHostKeyValue.value);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onSendMeetingCode(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const sendMeetingCodeValue = value;
            const key = this.calls.getKeyByCallId(sendMeetingCodeValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${sendMeetingCodeValue.callId}`);
                return;
            }
            if (this.control.sendMeetingCode === undefined) {
                this.log.warning('driver does not support sendMeetingCode; perhaps try dial instead');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                yield this.control.sendMeetingCode(key, sendMeetingCodeValue.value);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onSendVideo(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const sendVideoValue = value;
            const key = this.calls.getKeyByCallId(sendVideoValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${sendVideoValue.callId}`);
                return;
            }
            if (this.control.sendVideo === undefined) {
                this.log.error('expected sendVideo to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                const newValue = yield this.control.sendVideo(key, sendVideoValue.value);
                this.calls.sendVideo(key, newValue);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onSetReceiveGain(param, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const receiveGainValue = value;
            const key = this.calls.getKeyByCallId(receiveGainValue.callId);
            if (key === undefined) {
                this.log.error(`unknown callId = ${receiveGainValue.callId}`);
                return;
            }
            if (this.control.receiveGainRange === undefined) {
                this.log.error('expected receiveGainRange to be defined');
                return;
            }
            if (this.control.setReceiveGain === undefined) {
                this.log.error('expected setReceiveGain to be defined');
                return;
            }
            this.transport.removeCommands('poll');
            try {
                let convertedValue = convertNumber(receiveGainValue.value, volumeRanges.receiveGain.max, volumeRanges.receiveGain.min, this.control.receiveGainRange.max, this.control.receiveGainRange.min, this.control.receiveGainRange.round);
                const tags = [`set.receiveGain.${key}`];
                this.transport.removeCommands(tags);
                convertedValue = yield this.control.setReceiveGain(key, convertedValue, tags);
                this.calls.updateReceiveGain(key, convertedValue);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    updateParticipant(callId, participantKey, remove = false) {
        if (this.participantIds[callId] === undefined)
            this.participantIds[callId] = {};
        let participantId = this.participantIds[callId][participantKey];
        if (participantId === undefined) {
            participantId = Sutl.generateFirebaseId();
            this.participantIds[callId][participantKey] = participantId;
        }
        if (remove) {
            delete this.participantIds[callId][participantKey];
        }
        return participantId;
    }
    updateParticipants(callId, participants) {
        if (participants === undefined) {
            delete this.participantIds[callId];
            return undefined;
        }
        else {
            const newParticipants = {};
            if (this.participantIds[callId] === undefined) {
                const newParticipantIds = {};
                for (const [participantKey, participant] of Object.entries(participants)) {
                    const participantId = Sutl.generateFirebaseId();
                    newParticipantIds[participantKey] = participantId;
                    newParticipants[participantId] = participant;
                }
                this.participantIds[callId] = newParticipantIds;
            }
            else {
                for (const [participantKey, participant] of Object.entries(participants)) {
                    let participantId = this.participantIds[callId][participantKey];
                    if (participantId === undefined) {
                        participantId = Sutl.generateFirebaseId();
                        this.participantIds[callId][participantKey] = participantId;
                    }
                    newParticipants[participantId] = participant;
                }
            }
            return newParticipants;
        }
    }
}
